import { getJson, postJson } from '@/lib/apiConfig';

const VERSION = '_XyGQ1NG';

type GetAccountResp = { Id?: string; id?: string; [k: string]: any };
type GetContactResp = { Id?: string; id?: string; [k: string]: any };
type CreateLeadResp = { id?: string; Id?: string; [k: string]: any };

function okId<T extends { Id?: string; id?: string }>(r: T | null) {
  if (!r) return null;
  return r.Id ?? r.id ?? null;
}

async function get<T>(path: string): Promise<T | null> {
  try {
    const result = await getJson<T>(VERSION, path);
    return result;
  } catch (e: any) {
    const msg = String(e?.message || '');
    const status = e?.status || '';
    // 404 é comportamento esperado - significa que não encontrou o recurso
    // 401 também é tratado como "não encontrado" no contexto de registro (sem autenticação)
    // Isso é esperado porque os endpoints de busca podem requerer autenticação,
    // mas no registro não temos token ainda, então tratamos como "não encontrado"
    if (
      status === 404 || 
      status === 401 ||
      msg.includes('404') || 
      msg.includes('401') ||
      msg.includes('Unauthorized') ||
      msg.includes('Authentication Required') ||
      msg.includes('ERROR_CODE_NOT_FOUND') || 
      msg.includes('não encontrado')
    ) {
      return null;
    }
    throw e;
  }
}

async function post<T>(path: string, body: any): Promise<T> {
  const result = await postJson<T>(VERSION, path, body);
  return result;
}

export async function getAccountByCNPJ(cnpj: string) {
  const data = await get<GetAccountResp>(
    `sf/account?cnpj=${encodeURIComponent(cnpj)}`
  );
  return okId(data); // retorna string | null
}

// Versão que retorna o objeto completo da Account (para ler CE_Carteira_c)
export async function getAccountDataByCNPJ(cnpj: string) {
  const data = await get<Record<string, any>>(
    `sf/account?cnpj=${encodeURIComponent(cnpj)}`
  );
  return data; // objeto completo ou null
}

export async function getContactByEmail(email: string) {
  const data = await get<GetContactResp>(
    `sf/contact?email=${encodeURIComponent(email)}`
  );
  return okId(data); // retorna string | null
}

type LeadInput = {
  FirstName?: string;
  LastName: string;
  Email: string;
  Phone?: string;
  MobilePhone?: string;
  CNPJ?: string; // preencha para PJ
};

export async function createLead(input: LeadInput) {
  // Atenção: os nomes dos campos do Xano estão exatamente assim nas imagens
  const payload = {
    LastName: input.LastName,
    FirstName: input.FirstName ?? '',
    Phone: input.Phone ?? '',
    MobilePhone: input.MobilePhone ?? '',
    Email: input.Email,
    CNPJ: input.CNPJ ?? '',
  };
  const data = await post<CreateLeadResp>('sf/lead', payload);
  return okId(data); // id do Lead
}
